const uz = {
    meta: {
        title: "AI chat-bot mijozlar uchun: nimani yopadi va narxi",
        description:
            "AI chat bot mijozlar uchun: bot qaysi savollarni yopadi, qaysilarini yopa olmaydi, eskalatsiya qoidalari, narx 15 mln so'mdan va qaytim hisobi.",
        keywords: [
            "AI chat bot mijozlar uchun",
            "sun'iy intellekt chat bot narxi",
            "mijozlarga javob berishni avtomatlashtirish",
            "call-markaz yukini kamaytirish",
            "bot va operator o'rtasida uzatish",
            "AI agent narxi",
            "chat bot eskalatsiya qoidasi",
        ],
    },
    h1: "AI chat-bot yoki jonli operator: bot qaysi savollarni yopadi va qayerda zarar qiladi",
    lead:
        "Chat-bot mijozlarga javob berish xarajatini kamaytiradi — lekin faqat to'g'ri savollar to'plamida. Bu maqolada kiruvchi murojaatlarni uchta oqimga ajratamiz, botga berib bo'lmaydigan savollarni aniq sanaymiz va odamga uzatish qoidalarini tayyor ko'rinishda beramiz. Narx va qaytim hisobi ham bor.",
    category: "Sun'iy intellekt",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Chat-bot haqidagi bahs odatda noto'g'ri savoldan boshlanadi: bot odamni almashtiradimi? To'g'ri savol boshqacha — kiruvchi murojaatlarning qaysi qismi takrorlanadi va uni odamsiz yopish qancha pul tejaydi. Qolgan qismi baribir odamda qoladi va bu normal.",
        },

        { type: "h2", text: "Kiruvchi savollarni uchta oqimga ajrating" },
        {
            type: "p",
            text:
                "Loyihani boshlashdan oldin oxirgi ikki haftadagi yozishmalarni oching va har bir savolni uchta guruhdan biriga qo'ying. Bu bir kunlik ish, lekin butun byudjetni belgilaydi.",
        },
        {
            type: "list",
            items: [
                "To'liq avtomatlashtiriladigan: katalog, narx, ish vaqti, manzil, yetkazib berish shartlari, buyurtma holati, oddiy texnik ko'rsatkichlar.",
                "Yarim avtomatlashtiriladigan: tavsiya berish, ikki mahsulotni taqqoslash, o'lcham tanlash — bot birinchi variantni beradi, odam tasdiqlaydi.",
                "Faqat odam uchun: shikoyat, chegirma bo'yicha savdolashuv, nostandart hisob-kitob, muddati o'tgan to'lov, nizoli holat.",
            ],
        },
        {
            type: "p",
            text:
                "Amaliyotimizda birinchi guruh odatda kiruvchi savollarning yarmidan ko'pini tashkil qiladi, lekin bu ko'rsatkich sohaga qarab keskin farq qiladi. Aniq raqamni faqat o'z yozishmalaringizni sanab olasiz — boshqa kompaniyaning foizini o'zingizga ko'chirmang.",
        },
        {
            type: "p",
            text:
                "Sanashning oddiy usuli bor: Excel'ga ikkita ustun oching — savol matni va guruh raqami. Ikki haftalik yozishma odatda 200–400 qatorni beradi, uni bir kunda ko'rib chiqish mumkin. Shu jadval keyin bilimlar bazasining birinchi versiyasiga aylanadi va loyiha muddatini qisqartiradi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Bot qaysi savollarni yopa olmaydi?" },
        {
            type: "p",
            text:
                "Bu maqolaning eng muhim qismi. Quyidagi to'rt toifa botga berilsa, u foyda emas, zarar keltiradi — chunki noto'g'ri javob bergan bot bitta yo'qotilgan mijozdan ko'p qimmatga tushadi.",
        },
        {
            type: "list",
            items: [
                "Javobi sizning hujjatlaringizda yo'q savollar. Model bilmagan narsani ishonchli ohangda to'qib chiqarishi mumkin — buni gallyutsinatsiya deyiladi. Bilimlar bazasida javob bo'lmasa, bot javob bermasligi kerak.",
                "Pul bilan bog'liq nizolar. Qaytarish, kafolat bo'yicha bahs, muddati o'tgan to'lov, noto'g'ri yozilgan summa. Bu yerda mijozga hamdardlik va qaror qabul qilish huquqi kerak, ikkalasi ham botda yo'q.",
                "Shartnoma va huquqiy oqibatli javoblar. Bot aytgan shart keyin shartnomaga zid chiqsa, bahsda sizning tomoningiz zaif bo'ladi. Yuridik formulirovkani model emas, odam tasdiqlaydi.",
                "Emotsional murojaatlar. Mijoz jahli chiqqan holatda botning silliq javobi vaziyatni yomonlashtiradi. Salbiy kayfiyat aniqlangan zahoti suhbat odamga o'tishi kerak.",
            ],
        },
        {
            type: "p",
            text:
                "Alohida eslatma: tibbiy, yuridik va moliyaviy tavsiya beradigan bot qurish — yuqori xavf. Bunday sohada bot faqat ma'lumot beruvchi rolda qolishi va har javobda mutaxassisga yo'naltirishi kerak.",
        },

        { type: "h2", text: "Eskalatsiya qoidalari: bot qachon odamga uzatadi" },
        {
            type: "p",
            text:
                "Eskalatsiya — botni odamga uzatish mexanizmi. Aynan shu qism loyihaning sifatini belgilaydi va u texnik topshiriqda aniq yozilishi kerak. Quyidagi beshta trigger minimal to'plam hisoblanadi.",
        },
        {
            type: "table",
            head: ["Trigger", "Nima sodir bo'ladi", "Nima uchun kerak"],
            rows: [
                [
                    "Javob ishonchi past",
                    "Bot javob bermaydi, suhbatni operatorga uzatadi",
                    "Gallyutsinatsiyaning oldini oladi",
                ],
                [
                    "Bir savol ikki marta takrorlandi",
                    "Uchinchi urinishga yo'l qo'yilmaydi, odam ulanadi",
                    "Mijoz aylanma suhbatda qolib ketmaydi",
                ],
                [
                    "Salbiy kayfiyat aniqlandi",
                    "Darhol operatorga, suhbat tarixi bilan",
                    "Jahli chiqqan mijoz botdan yanada asabiylashadi",
                ],
                [
                    "To'lov yoki qaytarish mavzusi",
                    "Bot faqat ma'lumot beradi, qarorni odam qabul qiladi",
                    "Moliyaviy xatoning narxi yuqori",
                ],
                [
                    "Mijoz odamni so'radi",
                    "Bahssiz uzatiladi, ushlab qolishga urinilmaydi",
                    "Ushlab qolishga urinish ishonchni yo'qotadi",
                ],
            ],
        },
        {
            type: "callout",
            text:
                "Ish vaqtidan tashqari eskalatsiya alohida ishlanadi: bot ochiq aytadi — operator ertalab javob beradi — va aloqa ma'lumotini oladi. Javobsiz qolgan uzatish botning eng ko'p uchraydigan nosozligi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "AI chat-bot va oddiy bot o'rtasidagi farq" },
        {
            type: "p",
            text:
                "Tugmali bot oldindan yozilgan stsenariy bo'yicha ishlaydi: mijoz menyudan tanlaydi, bot tayyor matnni chiqaradi. U arzon, bashoratli va stsenariydan chetga chiqmaydi. Lekin mijoz erkin shaklda yozganda u tushunmaydi.",
        },
        {
            type: "p",
            text:
                "AI agent esa savolni tushunadi va javobni bilimlar bazasidan quradi. Undan tashqari u harakat qila oladi: ombordagi qoldiqni tekshiradi, summani hisoblaydi, buyurtma yaratadi va to'lov havolasini yuboradi. Farq shunda — birinchisi matn chiqaradi, ikkinchisi ishni oxiriga yetkazadi.",
        },
        {
            type: "p",
            text:
                "Tanlov mezoni oddiy: savollaringiz bir necha o'nlab qat'iy stsenariyga sig'sa, tugmali bot yetadi. Mijozlar erkin yozsa, savollar xilma-xil bo'lsa va katalog katta bo'lsa — AI agent kerak.",
        },

        { type: "h2", text: "AI agent qancha turadi?" },
        {
            type: "p",
            text:
                "Narx ikki qismdan iborat: bir martalik ishlab chiqish va oylik model API to'lovi. Ikkinchisini byudjetga kiritmaslik — eng ko'p uchraydigan xato.",
        },
        {
            type: "table",
            head: ["Tarif", "Narxi", "Muddat", "Nima kiradi"],
            rows: [
                [
                    "Start",
                    "15 mln so'mdan",
                    "3–4 hafta",
                    "Bitta kanal, bilimlar bazasi, ariza yig'ish, odamga uzatish",
                ],
                [
                    "Biznes",
                    "38 mln so'mdan",
                    "6–9 hafta",
                    "Telegram, WhatsApp, Instagram va sayt; buyurtma, CRM, to'lov havolasi",
                ],
                [
                    "Enterprise",
                    "Kelishuv asosida",
                    "3 oydan",
                    "O'z serveringizdagi model, ERP ulanishi, audit jurnali, SLA",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Oylik API xarajati suhbatlar soniga bog'liq: kuniga 50–150 suhbatda taxminan 250 000 – 900 000 so'm, kuniga 300–800 suhbatda 1 000 000 – 3 500 000 so'm. Bu summa to'g'ridan-to'g'ri provayderga to'lanadi. WhatsApp Business API ishlatilsa, Meta'ning xabar uchun alohida to'lovi ham qo'shiladi.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi" },
        {
            type: "p",
            text:
                "Hisobni to'rt qadamda qiling va o'z raqamlaringizni qo'ying. Natija botning kerak yoki keraksizligini o'zi ko'rsatadi.",
        },
        {
            type: "ol",
            items: [
                "Oyiga nechta murojaat keladi? Masalan, 2 000 ta.",
                "Nechasi takrorlanuvchi? Yozishmalarni sanang; aytaylik, 55 foizi — 1 100 ta.",
                "Bittasiga operator qancha vaqt sarflaydi? Masalan, 4 daqiqa — bu oyiga 73 soat.",
                "Bot ularning qancha qismini odamsiz yopadi? Realistik mo'ljal — 60–75 foiz, 100 emas.",
            ],
        },
        {
            type: "p",
            text:
                "73 soatning 65 foizi — oyiga 47 soat. Bir soat operator vaqti 35 000 so'm bo'lsa, tejamkorlik oyiga 1,65 mln so'm. API xarajatini 600 000 so'm deb olsak, sof natija 1 mln so'm atrofida. 15 mln so'mlik Start tarifi taxminan 15 oyda o'zini oqlaydi.",
        },
        {
            type: "p",
            text:
                "Lekin asosiy pul bu yerda emas. Ikkinchi manba — ish vaqtidan tashqari kelgan va javobsiz qolgan murojaatlar. Kechqurun va dam olish kunlari kelgan 200 ta murojaatning 10 foizi xaridga aylansa va o'rtacha chek 800 000 so'm bo'lsa, bu oyiga 16 mln so'mlik aylanma. Aynan shu raqam qaytim muddatini bir necha oyga qisqartiradi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Yomon qurilgan bot qancha zarar qiladi" },
        {
            type: "p",
            text:
                "Botning zarari ham o'lchanadi, faqat u hisobvaraqda ko'rinmaydi. Eng tipik to'rtta zarar quyidagicha.",
        },
        {
            type: "list",
            items: [
                "Noto'g'ri narx yoki shart aytilgan javob — keyin uni bajarishga to'g'ri keladi yoki mijoz bilan bahs boshlanadi.",
                "Aylanma suhbat: bot tushunmaydi, mijoz uch marta qayta yozadi va ketadi. Bu murojaat statistikada muvaffaqiyatli ko'rinadi.",
                "Odamga uzatish ishlamaydi yoki operator xabarni ko'rmaydi — mijoz javobsiz qoladi.",
                "Bilimlar bazasi yangilanmaydi: narx o'zgardi, bot eski raqamni aytadi. Uch oydan keyin bu tizimli muammoga aylanadi.",
            ],
        },
        {
            type: "p",
            text:
                "Shuning uchun loyihaga bilimlar bazasini yangilash tartibi va javob sifatini kuzatish kiritilishi kerak. Bot bir marta quriladigan narsa emas — u xizmat ko'rsatiladigan tizim.",
        },

        { type: "h2", text: "Qachon bot kerak emas" },
        {
            type: "list",
            items: [
                "Oyiga 100 tadan kam murojaat kelsa. Bu holatda operator arzonroq turadi.",
                "Har bir bitim nostandart bo'lsa: loyiha ishlari, individual ishlab chiqarish, yirik B2B kelishuvlar.",
                "Yozma bilimlar bazasi umuman yo'q bo'lsa. Avval narx, shart va savol-javoblarni yozing — bot ularsiz javob bera olmaydi.",
                "Mijozlar sizga asosan telefon orqali murojaat qilsa. Bunda avval matnli kanalni yo'lga qo'yish kerak.",
                "Oylik API va qo'llab-quvvatlash uchun byudjet ajratilmagan bo'lsa.",
            ],
        },

        { type: "h2", text: "Ishga tushirish: birinchi 60 kun" },
        {
            type: "ol",
            items: [
                "Ikki haftalik yozishmani sanang va savollarni uchta oqimga ajrating.",
                "Birinchi oqim uchun bilimlar bazasini yozing: narx, shart, tez-tez beriladigan savollar.",
                "Eskalatsiya qoidalarini kelishing va ularni texnik topshiriqqa kiriting.",
                "Bitta kanalda ishga tushiring — odatda Telegram yoki sayt vidjeti.",
                "Birinchi oyda har kuni 20 ta suhbatni qo'lda o'qing va xato javoblarni belgilang.",
                "Ko'rsatkichni o'lchang: odamsiz yopilgan suhbatlar ulushi, uzatish sababi, o'rtacha javob vaqti.",
            ],
        },
        {
            type: "p",
            text:
                "Oxirgi qadam eng ko'p tashlab ketiladigan qismi. O'lchovsiz bot ishlayaptimi yoki yo'qmi degan savol his-tuyg'u darajasida qoladi. Minimal to'plam to'rtta raqam: odamsiz yopilgan suhbatlar ulushi, uzatishning eng ko'p uchraydigan sababi, javobsiz qolgan uzatishlar soni va oylik API xarajati. Ularni har oy bir sahifada ko'rib chiqing.",
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "Yaxshi bot ko'p savolga javob beradigan bot emas — u qachon javob bermaslik kerakligini biladigan bot.",
        },
    ],

    faq: [
        {
            q: "AI chat-bot qancha turadi?",
            a: "Innobek'da Start tarifi 15 000 000 so'mdan boshlanadi — bu bitta kanalda ishlaydigan, bilimlar bazasidan javob beradigan va ariza yig'adigan agent. Buyurtma rasmiylashtiradigan, CRM'ga ulangan Biznes tarifi 38 000 000 so'mdan. Bu bir martalik to'lov. Model API'si uchun oylik xarajat alohida: suhbatlar soniga qarab 250 000 so'mdan 3 500 000 so'mgacha.",
        },
        {
            q: "Bot mijozlarning necha foiz savoliga javob bera oladi?",
            a: "Bu kiruvchi savollaringiz tarkibiga bog'liq va universal raqam yo'q. Ishonchli usul — oxirgi ikki haftalik yozishmani sanab, takrorlanuvchi savollar ulushini o'lchash. Shundan keyin realistik mo'ljal quyidagicha: bot takrorlanuvchi savollarning 60–75 foizini odamsiz yopadi. Kimdir 90 foiz va'da qilsa, u sizning ma'lumotingizni ko'rmagan.",
        },
        {
            q: "Bot noto'g'ri javob bersa nima bo'ladi?",
            a: "Til modeli gallyutsinatsiya qilishi mumkin — bilmagan narsasini ishonchli ohangda aytishi. Buning oldini olish uchun bot faqat sizning bilimlar bazangizdan javob beradi va javob topilmasa, suhbat operatorga uzatiladi. Birinchi oyda suhbatlar qo'lda tekshiriladi, xato javoblar belgilanadi va bilimlar bazasi to'ldiriladi. Bu ish loyihaga kiritilishi shart.",
        },
        {
            q: "Bot qaysi savollarni umuman olmasligi kerak?",
            a: "To'rt toifa: javobi hujjatlaringizda yo'q savollar, pul bilan bog'liq nizolar — qaytarish, kafolat, muddati o'tgan to'lov, huquqiy oqibatli javoblar va emotsional murojaatlar. Bu savollarda mijozga qaror qabul qilish huquqi va hamdardlik kerak, ikkalasi ham botda yo'q. Ular eskalatsiya qoidalari orqali darhol odamga uzatiladi.",
        },
        {
            q: "Bot operatorlarni ishdan bo'shatish imkonini beradimi?",
            a: "Amaliyotda yo'q va bunga mo'ljallamaslik kerak. Bot takrorlanuvchi savollarni oladi, operator esa murakkab va pul keltiradigan suhbatlarga ko'proq vaqt ajratadi. Ko'pchilik kompaniyada natija xodim sonini kamaytirish emas, o'sha jamoa bilan ikki barobar ko'p murojaatga xizmat ko'rsatish bo'ladi. Ish vaqtidan tashqari qamrov ham shu hisobdan keladi.",
        },
        {
            q: "Qachon AI chat-bot kerak emas?",
            a: "Oyiga 100 tadan kam murojaat kelsa, operator arzonroq turadi. Har bir bitim nostandart bo'lgan loyiha ishlari va yirik B2B kelishuvlarda ham bot foyda bermaydi. Yozma bilimlar bazasi bo'lmasa, avval narx va shartlarni hujjatlashtiring. Mijozlar asosan telefon qilsa, avval matnli kanalni yo'lga qo'ying. Oylik byudjet yo'q bo'lsa ham boshlamang.",
        },
    ],

    cta: {
        h: "Yozishmalaringizni bepul tahlil qilamiz",
        p:
            "Oxirgi ikki haftalik murojaatlarni ko'rib chiqamiz, qaysi qismi botga o'tishini va qaysi biri odamda qolishini aytamiz. Keyin aniq tarif, muddat va taxminiy oylik API xarajatini beramiz.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/ai-chatbot-uzatish.webp",
            alt: "Botdan jonli operatorga uzatilgan suhbat oynasi ikki qismga bo'lingan ko'rinishda",
            caption: "Loyihaning sifati aynan bot va odam o'rtasidagi chegarada hal bo'ladi",
            prompt:
                "Split conversation view: left a chat window handled by an AI assistant answering a routine question instantly, right the same thread escalated to a human operator at a desk; clean UI mockup plus soft office photo blend, blue and warm tones, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ai-chatbot-savol-triaji.webp",
            alt: "Kiruvchi savollarning uchta oqimga ajratilishini ko'rsatuvchi sxema",
            caption: "Uchta oqim: to'liq avtomatlashtiriladigan, yarim avtomatik va faqat odam uchun",
            prompt:
                "Question triage diagram: incoming questions split into three lanes — fully automatable (catalog, price, hours, order status), assisted (recommendation, comparison), human-only (complaint, negotiation, custom quote); clean flat three-lane infographic, green, amber and red lanes, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ai-chatbot-yuk-grafigi.webp",
            alt: "Bot ishga tushgach qo'llab-quvvatlash yukining o'zgarishini ko'rsatuvchi ustunli grafik",
            caption: "Takroriy murojaatlar ulushi kamayadi, murakkablari o'z o'rnida qoladi",
            prompt:
                "Support workload before-and-after chart: stacked bars showing repetitive versus complex requests per week, with the repetitive portion shrinking after bot launch; clean analytics style, teal and grey, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Tamam Uz bot loyihasi — Telegram orqali mijozlar bilan ishlash interfeysi",
            caption: "Tamam Uz bot — Innobek portfelidagi messenjer loyihasi",
        },
    ],

    relatedServices: ["ai-agent", "sun-iy-intellekt", "crm-tizimlar"],
    relatedPosts: ["ai-ni-kichik-biznesga-joriy-etish", "computer-vision-ombor-va-dokonda"],
};

const ru = {
    meta: {
        title: "AI-чат-бот для клиентов: что закрывает и сколько стоит",
        description:
            "AI-чат-бот для клиентов: какие вопросы бот закрывает, какие брать нельзя, правила передачи оператору, цена от 15 млн сум и расчёт окупаемости.",
        keywords: [
            "AI чат-бот для клиентов Узбекистан",
            "чат-бот с искусственным интеллектом цена",
            "автоматизация ответов клиентам",
            "снизить нагрузку на колл-центр",
            "передача диалога от бота оператору",
            "стоимость AI-агента",
            "правила эскалации чат-бота",
        ],
    },
    h1: "AI-чат-бот или живой оператор: какие вопросы закрывает бот и где он вредит",
    lead:
        "Чат-бот снижает стоимость ответа клиенту — но только на правильном наборе вопросов. Разделяем входящие обращения на три потока, честно перечисляем вопросы, которые боту отдавать нельзя, и даём готовые правила передачи диалога оператору. С ценами и расчётом окупаемости.",
    category: "Искусственный интеллект",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Спор о чат-ботах обычно начинается с неверного вопроса: заменит ли бот человека? Правильный вопрос другой — какая доля входящих обращений повторяется и сколько денег сэкономит их закрытие без оператора. Остальное всё равно останется за людьми, и это нормально.",
        },

        { type: "h2", text: "Разделите входящие вопросы на три потока" },
        {
            type: "p",
            text:
                "Прежде чем начинать проект, откройте переписку за последние две недели и отнесите каждый вопрос к одной из трёх групп. Это работа на один день, но именно она определяет бюджет.",
        },
        {
            type: "list",
            items: [
                "Полностью автоматизируемые: каталог, цена, часы работы, адрес, условия доставки, статус заказа, простые характеристики товара.",
                "Полуавтоматические: рекомендация, сравнение двух товаров, подбор размера — бот предлагает первый вариант, человек подтверждает.",
                "Только для человека: жалоба, торг по скидке, нестандартный расчёт, просроченный платёж, спорная ситуация.",
            ],
        },
        {
            type: "p",
            text:
                "По нашему опыту первая группа обычно занимает больше половины входящих, но разброс по отраслям огромный. Точную цифру вы получите только из собственной переписки — не переносите на себя процент чужой компании.",
        },
        {
            type: "p",
            text:
                "Считать проще всего в Excel: два столбца — текст вопроса и номер группы. Переписка за две недели обычно даёт 200–400 строк, и разобрать их можно за день. Эта же таблица потом становится первой версией базы знаний и заметно сокращает срок проекта.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Какие вопросы бот закрыть не может?" },
        {
            type: "p",
            text:
                "Это самая важная часть статьи. Четыре категории ниже, отданные боту, приносят не пользу, а убыток — неверный ответ обходится дороже, чем один потерянный клиент.",
        },
        {
            type: "list",
            items: [
                "Вопросы, ответа на которые нет в ваших документах. Модель может уверенным тоном придумать то, чего не знает — это и есть галлюцинация. Если ответа в базе знаний нет, бот отвечать не должен.",
                "Денежные споры: возврат, спор по гарантии, просроченный платёж, неверно выставленная сумма. Здесь нужны сочувствие и право принять решение, а у бота нет ни того, ни другого.",
                "Ответы с юридическими последствиями. Если условие, названное ботом, противоречит договору, ваша позиция в споре слабее. Юридические формулировки подтверждает человек, а не модель.",
                "Эмоциональные обращения. Когда клиент раздражён, гладкий ответ бота только усиливает раздражение. Как только бот замечает негатив, диалог должен сразу уходить человеку.",
            ],
        },
        {
            type: "p",
            text:
                "Отдельная оговорка: бот, дающий медицинские, юридические или финансовые советы, — зона высокого риска. В таких сферах бот остаётся справочным и в каждом ответе направляет к специалисту.",
        },

        { type: "h2", text: "Правила эскалации: когда бот передаёт диалог человеку" },
        {
            type: "p",
            text:
                "Эскалация — механизм передачи диалога оператору. Именно она определяет качество проекта и должна быть чётко прописана в техническом задании. Пять триггеров ниже — минимальный набор.",
        },
        {
            type: "table",
            head: ["Триггер", "Что происходит", "Зачем это нужно"],
            rows: [
                [
                    "Низкая уверенность в ответе",
                    "Бот не отвечает и передаёт диалог оператору",
                    "Предотвращает галлюцинацию",
                ],
                [
                    "Вопрос повторён дважды",
                    "Третья попытка не допускается, подключается человек",
                    "Клиент не застревает в замкнутом круге",
                ],
                [
                    "Обнаружен негатив",
                    "Немедленная передача вместе с историей диалога",
                    "Раздражённого клиента бот злит ещё больше",
                ],
                [
                    "Тема оплаты или возврата",
                    "Бот только информирует, решение принимает человек",
                    "Цена финансовой ошибки высока",
                ],
                [
                    "Клиент попросил человека",
                    "Передача без возражений и попыток удержать",
                    "Попытка удержать разрушает доверие",
                ],
            ],
        },
        {
            type: "callout",
            text:
                "Эскалация вне рабочего времени прорабатывается отдельно: бот честно предупреждает, что оператор ответит утром, и забирает контакт. Переданный, но оставшийся без ответа диалог — самый частый сбой в работе ботов.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Чем AI-агент отличается от обычного бота" },
        {
            type: "p",
            text:
                "Кнопочный бот работает по заранее написанному сценарию: клиент выбирает пункт меню, бот выдаёт готовый текст. Он дёшев, предсказуем и не выходит за рамки сценария. Но как только клиент пишет свободным текстом, он перестаёт понимать.",
        },
        {
            type: "p",
            text:
                "AI-агент понимает вопрос и строит ответ по базе знаний. Кроме того, он умеет действовать: проверить остаток на складе, посчитать сумму, создать заказ и прислать ссылку на оплату. Разница в этом — первый выдаёт текст, второй доводит дело до конца.",
        },
        {
            type: "p",
            text:
                "Критерий выбора простой. Если ваши вопросы укладываются в несколько десятков жёстких сценариев, хватит кнопочного бота. Если клиенты пишут свободно, вопросы разнородные, а каталог большой — нужен AI-агент.",
        },

        { type: "h2", text: "Сколько стоит AI-агент?" },
        {
            type: "p",
            text:
                "Цена состоит из двух частей: разовая разработка и ежемесячная оплата API модели. Забыть про вторую — самая частая ошибка при планировании.",
        },
        {
            type: "table",
            head: ["Тариф", "Цена", "Срок", "Что входит"],
            rows: [
                [
                    "Start",
                    "от 15 млн сум",
                    "3–4 недели",
                    "Один канал, база знаний, сбор заявок, передача оператору",
                ],
                [
                    "Бизнес",
                    "от 38 млн сум",
                    "6–9 недель",
                    "Telegram, WhatsApp, Instagram и сайт; заказы, CRM, ссылка на оплату",
                ],
                [
                    "Enterprise",
                    "По договору",
                    "от 3 месяцев",
                    "Модель на вашем сервере, подключение ERP, журнал аудита, SLA",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Расход на API зависит от числа диалогов: при 50–150 диалогах в день это примерно 250 000 – 900 000 сум, при 300–800 — от 1 000 000 до 3 500 000 сум в месяц. Сумма платится напрямую провайдеру. Для WhatsApp Business API добавляется отдельная плата Meta за сообщения.",
        },

        { type: "h2", text: "Как считается окупаемость" },
        {
            type: "p",
            text:
                "Посчитайте в четыре шага, подставив свои цифры. Результат сам покажет, нужен вам бот или нет.",
        },
        {
            type: "ol",
            items: [
                "Сколько обращений приходит в месяц? Допустим, 2 000.",
                "Сколько из них повторяющихся? Посчитайте по переписке; пусть будет 55 процентов — 1 100.",
                "Сколько времени оператор тратит на одно обращение? Например, 4 минуты — это 73 часа в месяц.",
                "Какую долю бот закроет без человека? Реалистичный ориентир — 60–75 процентов, а не 100.",
            ],
        },
        {
            type: "p",
            text:
                "65 процентов от 73 часов — это 47 часов в месяц. При стоимости часа оператора 35 000 сум экономия составит около 1,65 млн сум. Если расход на API — 600 000 сум, чистый результат примерно 1 млн сум в месяц, и тариф Start за 15 млн сум окупается примерно за 15 месяцев.",
        },
        {
            type: "p",
            text:
                "Но основные деньги не здесь. Второй источник — обращения, пришедшие вне рабочего времени и оставшиеся без ответа. Если из 200 вечерних и выходных обращений покупкой станут 10 процентов при среднем чеке 800 000 сум, это 16 млн сум оборота в месяц. Именно эта цифра сокращает срок окупаемости до нескольких месяцев.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько вреда приносит плохо собранный бот" },
        {
            type: "p",
            text:
                "Ущерб от бота тоже измерим, просто он не виден в отчёте. Четыре самых типичных случая ниже.",
        },
        {
            type: "list",
            items: [
                "Бот назвал неверную цену или условие — потом это придётся выполнять либо спорить с клиентом.",
                "Диалог по кругу: бот не понимает, клиент переписывает вопрос трижды и уходит. В статистике такое обращение выглядит успешным.",
                "Передача оператору не срабатывает или оператор не видит уведомление — клиент остаётся без ответа.",
                "База знаний не обновляется: цена изменилась, бот называет старую. Через три месяца это становится системной проблемой.",
            ],
        },
        {
            type: "p",
            text:
                "Поэтому в проект обязательно закладываются регламент обновления базы знаний и мониторинг качества ответов. Бот — не разовая поделка, а система, которую обслуживают.",
        },

        { type: "h2", text: "Когда бот не нужен" },
        {
            type: "list",
            items: [
                "Меньше 100 обращений в месяц. В этом случае оператор обойдётся дешевле.",
                "Каждая сделка нестандартна: проектные работы, индивидуальное производство, крупные B2B-контракты.",
                "Нет письменной базы знаний. Сначала зафиксируйте цены, условия и типовые ответы — без них бот отвечать не сможет.",
                "Клиенты обращаются в основном по телефону. Тогда сначала нужно наладить текстовый канал.",
                "Не выделен бюджет на ежемесячный API и поддержку.",
            ],
        },

        { type: "h2", text: "Запуск: первые 60 дней" },
        {
            type: "ol",
            items: [
                "Посчитайте переписку за две недели и разложите вопросы на три потока.",
                "Напишите базу знаний для первого потока: цены, условия, частые вопросы.",
                "Согласуйте правила эскалации и внесите их в техническое задание.",
                "Запуститесь в одном канале — обычно это Telegram или виджет на сайте.",
                "В первый месяц читайте вручную по 20 диалогов в день и помечайте неверные ответы.",
                "Измеряйте показатели: доля диалогов без человека, причины передач, среднее время ответа.",
            ],
        },
        {
            type: "p",
            text:
                "Именно последний шаг чаще всего пропускают. Без измерений вопрос о том, работает ли бот, остаётся на уровне ощущений. Минимальный набор — четыре числа: доля диалогов, закрытых без человека, самая частая причина передачи, количество передач, оставшихся без ответа, и месячный расход на API. Смотрите их раз в месяц на одной странице.",
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "Хороший бот — не тот, который отвечает на всё, а тот, который знает, когда отвечать не нужно.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит AI-чат-бот?",
            a: "В Innobek тариф Start начинается от 15 000 000 сум — это агент в одном канале, который отвечает по базе знаний и собирает заявки. Тариф Бизнес с оформлением заказов и интеграцией CRM — от 38 000 000 сум. Это разовая оплата. Расход на API модели считается отдельно: от 250 000 до 3 500 000 сум в месяц в зависимости от числа диалогов.",
        },
        {
            q: "На какую долю вопросов бот сможет ответить?",
            a: "Это зависит от структуры ваших обращений, универсальной цифры не существует. Надёжный способ — посчитать переписку за две недели и измерить долю повторяющихся вопросов. После этого реалистичный ориентир такой: бот закрывает 60–75 процентов повторяющихся обращений без человека. Если вам обещают 90 процентов, ваши данные никто не смотрел.",
        },
        {
            q: "Что будет, если бот ответит неправильно?",
            a: "Языковая модель может галлюцинировать — уверенно сказать то, чего не знает. Чтобы этого не происходило, бот отвечает только по вашей базе знаний, а при отсутствии ответа передаёт диалог оператору. В первый месяц диалоги проверяются вручную, неверные ответы помечаются, база знаний дополняется. Эта работа должна входить в проект.",
        },
        {
            q: "Какие вопросы боту отдавать нельзя?",
            a: "Четыре категории: вопросы, ответа на которые нет в ваших документах; денежные споры — возврат, гарантия, просроченный платёж; ответы с юридическими последствиями; эмоциональные обращения. Здесь клиенту нужны сочувствие и право на решение, а у бота нет ни того, ни другого. Такие диалоги правила эскалации сразу переводят на человека.",
        },
        {
            q: "Можно ли будет сократить операторов?",
            a: "На практике нет, и рассчитывать на это не стоит. Бот забирает повторяющиеся вопросы, а оператор получает больше времени на сложные и денежные диалоги. У большинства компаний результат не в сокращении штата, а в том, что та же команда обслуживает вдвое больше обращений. Плюс появляется покрытие вне рабочего времени.",
        },
        {
            q: "Когда AI-чат-бот не нужен?",
            a: "Если обращений меньше 100 в месяц, оператор обойдётся дешевле. В проектных работах и крупных B2B-сделках, где каждая сделка индивидуальна, бот пользы не принесёт. Нет письменной базы знаний — сначала зафиксируйте цены и условия. Клиенты звонят, а не пишут — сначала наладьте текстовый канал. Нет бюджета на месячный API — не начинайте.",
        },
    ],

    cta: {
        h: "Бесплатно разберём вашу переписку",
        p:
            "Посмотрим обращения за последние две недели и скажем, какая часть уйдёт боту, а какая останется людям. Затем назовём тариф, срок и ориентир по ежемесячному расходу на API.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/ai-chatbot-uzatish.webp",
            alt: "Диалог, переданный от бота живому оператору, показан в виде разделённого экрана",
            caption: "Качество проекта решается именно на границе между ботом и человеком",
            prompt:
                "Split conversation view: left a chat window handled by an AI assistant answering a routine question instantly, right the same thread escalated to a human operator at a desk; clean UI mockup plus soft office photo blend, blue and warm tones, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ai-chatbot-savol-triaji.webp",
            alt: "Схема разделения входящих вопросов на три потока обработки",
            caption: "Три потока: полностью автоматизируемый, полуавтоматический и только для человека",
            prompt:
                "Question triage diagram: incoming questions split into three lanes — fully automatable (catalog, price, hours, order status), assisted (recommendation, comparison), human-only (complaint, negotiation, custom quote); clean flat three-lane infographic, green, amber and red lanes, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ai-chatbot-yuk-grafigi.webp",
            alt: "Столбчатый график изменения нагрузки на поддержку после запуска бота",
            caption: "Доля повторяющихся обращений падает, сложные остаются на месте",
            prompt:
                "Support workload before-and-after chart: stacked bars showing repetitive versus complex requests per week, with the repetitive portion shrinking after bot launch; clean analytics style, teal and grey, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Проект Tamam Uz bot — интерфейс работы с клиентами через Telegram",
            caption: "Tamam Uz bot — проект Innobek в мессенджерах",
        },
    ],

    relatedServices: ["ai-agent", "sun-iy-intellekt", "crm-tizimlar"],
    relatedPosts: ["ai-ni-kichik-biznesga-joriy-etish", "computer-vision-ombor-va-dokonda"],
};

const content = { uz, ru };

export default content;
